import { toast } from 'react-toastify';
import { apiClient } from './client';
import { handleApiError } from './utils';

export const assignArbitrationToSelf = async ({ arbitrationId }) => {
    if (!arbitrationId) {
        toast.error('Kendine atama işlemi için tahkim ID\'si gereklidir.');
        throw new Error('Arbitration ID is missing for assign arbitration to self request.');
    }

    const apiEndpoint = `/Arbitration/assign-task-to-user/${arbitrationId}`;

    try {
        const response = await apiClient.put(apiEndpoint);
        return response.data;

    } catch (error) {
        handleApiError(error, 'Tahkim kendine atama işlemi sırasında hata oluştu.');
        throw error;
    }
};

export const releaseArbitrationFromSelf = async ({ arbitrationId }) => {
    if (!arbitrationId) {
        toast.error('Kendinden kaldırma işlemi için tahkim ID\'si gereklidir.');
        throw new Error('Arbitration ID is missing for release arbitration from self request.');
    }

    const apiEndpoint = `/Arbitration/release-task-from-user/${arbitrationId}`;

    try {
        const response = await apiClient.put(apiEndpoint);
        return response.data;

    } catch (error) {
        handleApiError(error, 'Tahkim kendinden kaldırma işlemi sırasında hata oluştu.');
        throw error;
    }
};

export const handleStateTransition = async ({
    arbitrationId,
    goToPayCounterPoaFee = false,
    goToPayObjectionFee = false,
    goToEnforcement = false,
    goToPayTrackingDetailFee = false,
    goToPayCollectionFee = false
}) => {
    if (!arbitrationId) {
        toast.error('Durum değiştirmek için tahkim ID\'si gereklidir.');
        throw new Error('Arbitration ID is missing for state transition.');
    }

    try {
        const endpoint = `/Arbitration/${arbitrationId}/state`;

        const params = {};
        if (goToPayCounterPoaFee) {
            params.goToPayCounterPoaFee = true;
        }
        if (goToPayObjectionFee) {
            params.goToPayObjectionFee = true;
        }
        if (goToEnforcement) {
            params.goToEnforcement = true;
        }
        if (goToPayTrackingDetailFee) {
            params.goToPayTrackingDetailFee = true;
        }
        if (goToPayCollectionFee) {
            params.goToPayCollectionFee = true;
        }

        const response = await apiClient.put(endpoint, null, { params });
        if (response.status >= 200 && response.status < 300) {
            toast.success('Durum başarıyla değiştirildi');
            return response.data;
        } else {
            throw new Error(`Unexpected response status: ${response.status}`);
        }

    } catch (error) {
        handleApiError(error, 'Durum değiştirme işlemi başarısız oldu.', {
            toastPrefix: 'Durum değiştirme işlemi başarısız oldu: '
        });

        throw error;
    }
};

export const startReapplicationFlow = async ({ reapplicationId }) => {
    if (!reapplicationId) {
        toast.error('Akış başlatmak için tekrar başvuru ID\'si gereklidir.');
        throw new Error('Reapplication ID is missing for starting reapplication flow.');
    }

    try {
        const endpoint = `/ReapplicationInformation/change-state/${reapplicationId}`;

        const response = await apiClient.patch(endpoint, {});
        if (response.status >= 200 && response.status < 300) {
            toast.success('Tekrar başvuru akışı başarıyla başlatıldı');
            return response.data;
        } else {
            throw new Error(`Unexpected response status: ${response.status}`);
        }

    } catch (error) {
        handleApiError(error, 'Akış başlatma işlemi başarısız oldu.', {
            toastPrefix: 'Akış başlatma işlemi başarısız oldu: '
        });

        throw error;
    }
};

export const patchArbitrationInformation = async ({ arbitrationInformationId, payload }) => {
    if (!arbitrationInformationId) {
        toast.error('Tahkim bilgisi güncellemesi için ID gereklidir.');
        throw new Error('Arbitration information ID is missing.');
    }
    if (!payload || payload.arbitrationApplicationFee === null || payload.arbitrationApplicationFee === undefined || String(payload.arbitrationApplicationFee).trim() === '') {
        toast.error('Tahkim başvuru ücreti gereklidir.');
        throw new Error('Arbitration application fee is missing.');
    }
    if (!String(payload.code || '').trim()) {
        toast.error('Tahkim kodu gereklidir.');
        throw new Error('Arbitration code is missing.');
    }
    if (!payload.applicationDate) {
        toast.error('Tahkim başvuru tarihi gereklidir.');
        throw new Error('Arbitration application date is missing.');
    }
    if (!String(payload.caseNumber || '').trim()) {
        toast.error('Tahkim esas numarası gereklidir.');
        throw new Error('Arbitration case number is missing.');
    }
    if (payload.priceForNow === null || payload.priceForNow === undefined || String(payload.priceForNow).trim() === '') {
        toast.error('Şimdilik tutarı gereklidir.');
        throw new Error('Arbitration price for now is missing.');
    }

    try {
        const response = await apiClient.put(`/Arbitration/patch-arbitration-information/${arbitrationInformationId}`, payload);
        return response.data;
    } catch (error) {
        handleApiError(error, 'Tahkim bilgileri güncellenirken bir hata oluştu.');
        throw error;
    }
};

export const createArbitrationWithFee = async ({ accidentFileId, arbitrationApplicationFee, code = '', applicationDate = null, caseNumber = '', priceForNow = null, requestBody = null }) => {
    if (!requestBody) {
        if (!accidentFileId) {
            toast.error('Tahkim başvurusu için kaza dosyası ID gereklidir.');
            throw new Error('Accident file ID is missing for arbitration creation.');
        }
        if (arbitrationApplicationFee === null || arbitrationApplicationFee === undefined || String(arbitrationApplicationFee).trim() === '') {
            toast.error('Tahkim başvuru ücreti gereklidir.');
            throw new Error('Arbitration application fee is missing.');
        }
        if (!String(code || '').trim()) {
            toast.error('Tahkim kodu gereklidir.');
            throw new Error('Arbitration code is missing.');
        }
        if (!applicationDate) {
            toast.error('Tahkim başvuru tarihi gereklidir.');
            throw new Error('Arbitration application date is missing.');
        }
        if (!String(caseNumber || '').trim()) {
            toast.error('Tahkim esas numarası gereklidir.');
            throw new Error('Arbitration case number is missing.');
        }
        if (priceForNow === null || priceForNow === undefined || String(priceForNow).trim() === '') {
            toast.error('Şimdilik tutarı gereklidir.');
            throw new Error('Arbitration price for now is missing.');
        }
    }

    try {
        const payload = requestBody || {
            arbitrationDto: {
                appointedUser: [],
                arbitrationState: [],
                accidentFile: [accidentFileId.toString()],
                arbitrationInformation: []
            },
            arbitrationInformationDto: {
                arbitration: [],
                applicationDate: applicationDate,
                caseNumber: String(caseNumber || '').trim(),
                priceForNow,
                arbitrationApplicationFee: arbitrationApplicationFee,
                code: String(code || '').trim(),
                expenses: []
            }
        };

        const response = await apiClient.post('/Arbitration', payload);
        return response.data;
    } catch (error) {
        handleApiError(error, 'Başvuru ücreti kaydedilirken bir hata oluştu.');
        throw error;
    }
};
